
export const redirectToURL = (repositoryUrl) => {
    if (repositoryUrl) {
      window.open(repositoryUrl, '_blank');
    }
  };
  